export default "__VITE_ASSET__923a6123__"